// Polyfills for module loading race conditions
// This ensures critical APIs are available even if there's a race condition in bundle loading

declare global {
  interface Window {
    scheduler?: {
      unstable_now?: () => number
    }
    exports?: Record<string, unknown>
    module?: {
      exports?: Record<string, unknown>
    }
    define?: (...args: unknown[]) => void
    global?: typeof globalThis
    require: (id: string) => unknown
  }

  // eslint-disable-next-line no-var
  var unstable_now: (() => number) | undefined
  // eslint-disable-next-line no-var
  var exports: Record<string, unknown> | undefined
  // eslint-disable-next-line no-var
  var module: { exports?: Record<string, unknown> } | undefined
  // eslint-disable-next-line no-var
  var define: ((...args: unknown[]) => void) | undefined
  // eslint-disable-next-line no-var
  var global: typeof globalThis | undefined
  // eslint-disable-next-line no-var
  var require: (id: string) => unknown
}

// React Scheduler Polyfill
if (typeof globalThis !== 'undefined' && !globalThis.unstable_now) {
  // Use performance.now() if available, otherwise fall back to Date.now()
  globalThis.unstable_now =
    typeof performance !== 'undefined' && typeof performance.now === 'function'
      ? () => performance.now()
      : () => Date.now()
}

// Ensure the scheduler object exists for React 19
if (typeof window !== 'undefined' && !window.scheduler) {
  window.scheduler = {
    unstable_now: globalThis.unstable_now,
  }
}

// CommonJS Module Exports Polyfill
// Some bundled modules expect these globals to exist during initialization
if (typeof globalThis !== 'undefined') {
  // Initialize exports object if it doesn't exist
  if (!globalThis.exports) {
    globalThis.exports = {}
  }

  // Initialize module.exports if it doesn't exist
  if (!globalThis.module) {
    globalThis.module = {
      exports: globalThis.exports,
    }
  } else if (!globalThis.module.exports) {
    globalThis.module.exports = globalThis.exports
  }
}

// Additional Module System Polyfills
// These provide safety nets for modules that expect these globals to exist
if (typeof globalThis !== 'undefined') {
  // AMD/UMD define polyfill - some bundled modules check for this
  if (!globalThis.define) {
    const defineFunc = () => {
      // No-op: Let the bundler handle loading instead
    }
    // TypeScript-friendly way to add amd property
    Object.assign(defineFunc, { amd: true })
    globalThis.define = defineFunc
  }

  // Global reference polyfill for older modules
  if (!globalThis.global) {
    globalThis.global = globalThis
  }

  // Enhanced require polyfill for bundler compatibility
  if (!globalThis.require) {
    // Create a require function that works with bundled assets
    globalThis.require = (id: string) => {
      // For bundled assets (like SVG files), the bundler should handle this
      // This polyfill exists primarily for module existence checks
      if (
        typeof id === 'string' &&
        (id.endsWith('.svg') || id.endsWith('.png') || id.endsWith('.jpg'))
      ) {
        // Return the id itself for asset imports - bundler will resolve
        return id
      }
      throw new Error(`Polyfill require: Module '${id}' not found. Use ES6 imports instead.`)
    }
  }
}

// Ensure window also has these for browser contexts
if (typeof window !== 'undefined') {
  if (!window.exports) {
    window.exports = globalThis.exports || {}
  }

  if (!window.module) {
    window.module = {
      exports: window.exports,
    }
  } else if (!window.module.exports) {
    window.module.exports = window.exports
  }

  // Mirror essential polyfills to window context (excluding process)
  if (!window.define && globalThis.define) {
    window.define = globalThis.define
  }

  if (!window.global && globalThis.global) {
    window.global = globalThis.global
  }

  if (!window.require) {
    window.require =
      globalThis.require ||
      ((id: string) => {
        if (
          typeof id === 'string' &&
          (id.endsWith('.svg') || id.endsWith('.png') || id.endsWith('.jpg'))
        ) {
          return id
        }
        throw new Error(`Polyfill require: Module '${id}' not found. Use ES6 imports instead.`)
      })
  }
}

export {}
